module.exports = __webpack_public_path__ + "static/media/logos.229f7be2.png";